import { Theme } from '@mui/material';

export const MuiPickersDay = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      color: 'red',
      '&:hover': {
        backgroundColor: theme.palette.surface.dim,
      },
      '&.Mui-selected': {
        color: theme.palette.primary.onColor,
      },
      '&.MuiPickersDay-today': {
        borderColor: theme.palette.primary.onColor,
      },
    }),
  },
};
